import Route from '@ember/routing/route'
import { service } from '@ember/service'
import { Changeset } from 'ember-changeset'
import type Store from '@ember-data/store'
import type RouterService from '@ember/routing/router-service'
import type { IntlService } from 'ember-intl'
import lookupValidator from 'teacher-ui-client/utils/lookup-validator'
import { editClassValidator } from 'teacher-ui-client/school-class/validator'
import type { ManageClassesModel } from 'teacher-ui-client/manage/classes/route'
import type { BufferedChangeset } from 'ember-changeset/types'
import type SchoolClass from 'teacher-ui-client/models/school-class'

interface Params extends Record<string, unknown> {
  school_class_id: string
}

export default class ManageClassesEditClassRoute extends Route {
  @service intl!: IntlService

  @service store!: Store

  @service router!: RouterService

  model({ school_class_id: schoolClassId }: Params) {
    const { subscriptionType } = this.modelFor('subscription-type') as ModelForSubscriptionTypeRoute
    const { teachers } = this.modelFor('manage.classes') as ManageClassesModel

    const schoolClass = this.store.peekRecord<SchoolClass>('school-class', schoolClassId)

    if (schoolClass) {
      const changeset = Changeset(
        schoolClass,
        lookupValidator(editClassValidator, { intl: this.intl }),
        editClassValidator,
      ) as BufferedChangeset & SchoolClass
      return { schoolClass, changeset, teachers: teachers.slice(), subscriptionType }
    } else {
      void this.router.replaceWith('manage.classes')
      return
    }
  }
}
